/* istanbul ignore file */
import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconFlagBearer({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <g
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.625}
          clipPath='url(#flag-bearer_svg__a)'
        >
          <path d='M20.651 23.25a6.73 6.73 0 0 0-6.337-4.5h-.006a6.73 6.73 0 0 0-6.336 4.5M10.754 11.03a6.86 6.86 0 0 0 7.646 1.537' />
          <path d='M10.183 13.125a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0M1.975 15.75a3 3 0 1 0 6 0 3 3 0 0 0-6 0M5.864 20.338A4.48 4.48 0 0 0 .75 23.25M14.311 18.75v4.5' />
          <path d='M23.25 23.25V.75H10.5l3 3-3 3h12.75' />
        </g>
        <defs>
          <clipPath id='flag-bearer_svg__a'>
            <path fill='currentColor' d='M0 0h24v24H0z' />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
IconFlagBearer.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconFlagBearer
